module.exports = __webpack_public_path__ + "6a2bc7eab5fc59b6fcb3f2f81f9ede48.fbx";